import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "./../_helpers";

let UserRole = {
  SuperAdmin: "SuperAdmin",
  Admin: "Admin",
  OrderAnalyst: "OrderAnalyst",
  WarehouseManager: "WarehouseManager",
  Dispatcher: "Dispatcher",
  WarehouseAssistant: "WarehouseAssistant",
  Accountant: "Accountant",
  OpsAdmin: "OpsAdmin",
};
// create slice

const name = "auth";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = (builder) => {
  createExtraReducers(builder);
};
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state from local storage to enable user to stay logged in
    permissionList: UserRole,
    user: JSON.parse(localStorage.getItem("user")),
    userSecurityDetail: null,
    NotificationCount: localStorage.getItem("NotificationCount"),
    error: null,
  };
}

function createReducers() {
  return {
    logout,
    updateLocalStorage,
  };

  function logout(state) {
    state.user = null;
    state.NotificationCount = 0;
    localStorage.removeItem("user");
    localStorage.removeItem("NotificationCount");
    if (localStorage.getItem("filterValues")) {
      localStorage.removeItem("filterValues");
    }

    if (localStorage.getItem("storeValues")) {
      localStorage.removeItem("storeValues");
    }
    if (localStorage.getItem("stockValues")) {
      localStorage.removeItem("stockValues");
    }

    if (localStorage.getItem("selectedProduct")) {
      localStorage.removeItem("selectedProduct");
    }
    if (localStorage.getItem("transactionTable")) {
      localStorage.removeItem("transactionTable");
    }
    history.navigate("/login");
  }

  function updateLocalStorage(state, action) {
    localStorage.setItem(
      "NotificationCount",
      action?.payload?.NotificationCount
    );
    state.NotificationCount = action?.payload?.NotificationCount;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/Login`;
  return {
    login: login(),
    loginVerifyCode: loginVerifyCode(),
    forgotpassword: forgotpassword(),
  };

  function login() {
    return createAsyncThunk(
      `${name}/login`,
      async ({ username, password }) =>
        await fetchWrapper.post(`${baseUrl}/authenticate`, {
          username,
          password,
        })
    );
  }

  //ForgotPassword
  function forgotpassword() {
    return createAsyncThunk(`${name}/forgotpassword`, async ({ username }) => {
      // Change parameter from mailid to username
      try {
        console.log("Sending username:", username); // Debug log

        // Use query parameter for GET request
        const response = await fetchWrapper.get(
          `${baseUrl}/UserForgotPassword?username=${encodeURIComponent(
            username
          )}`
        );
        console.log("Sending username 2:", username);
        return response;
      } catch (error) {
        console.error("Error during password reset:", error);
        throw error;
      }
    });
  }

  function loginVerifyCode() {
    return createAsyncThunk(
      `${name}/loginVerifyCode`,
      async (VerifyCode) =>
        await fetchWrapper.post(`${baseUrl}/CheckOTP`, VerifyCode)
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.login.pending, (state) => {
      state.error = null;
    })

    .addCase(extraActions.login.fulfilled, (state, action) => {
      const userSecurity = action.payload;
      if (userSecurity && userSecurity.OutputStatus === 1) {
        state.user = [];
        state.userSecurityDetail = userSecurity;
      } else {
        state.user = [];
        state.userSecurityDetail = userSecurity;
      }
    })
    .addCase(extraActions.login.rejected, (state, action) => {
      state.user = [];
      state.error = action.error;
    })
    .addCase(extraActions.loginVerifyCode.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.loginVerifyCode.fulfilled, (state, action) => {
      const user = action.payload;
      if (user && user.OutputStatus === 1) {
        localStorage.setItem("user", JSON.stringify(user));
        state.userSecurityDetail = [];
        state.user = user;
        state.NotificationCount = user?.NotificationCount;

        // Determine the path based on UserTypeID
        let path = "";
        if (
          user.UserTypeID === 1 ||
          user.UserTypeID === 2 ||
          user.UserTypeID === 8
        ) {
          path = "dashboard";
        } else if (user.UserTypeID === 3 || user.UserTypeID === 4) {
          path = "OrderList";
        } else if (user.UserTypeID === 5 || user.UserTypeID === 6) {
          path = "StockManagement";
        } else if (user.UserTypeID === 7) {
          path = "ProductStock";
        }

        const { from } = history.location.state || {
          from: { pathname: "/" + path },
        };
        history.navigate(from);
      } else {
        state.user = user;
        state.NotificationCount = user?.NotificationCount;
      }
    })
    .addCase(extraActions.loginVerifyCode.rejected, (state, action) => {
      state.error = action.error;
    })

    // Forgot Password Cases
    .addCase(extraActions.forgotpassword.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    })
    .addCase(extraActions.forgotpassword.fulfilled, (state, action) => {
      console.log("Forgot Password Response:", action.payload); // Log the response
      state.isLoading = false;
      state.forgotPasswordResponse = action.payload;
      state.error = null;
    })

    .addCase(extraActions.forgotpassword.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message || "Something went wrong.";
    });
}
